import React from "react";

import MenuItem from "bnb-ui/dist/MenuItem";

import List from "@material-ui/core/List";
import HomeIcon from "@material-ui/icons/Home";
import ArrowRightOutlinedIcon from "@material-ui/icons/ArrowRightOutlined";

import "./menuList.css";
import { SystemPath } from "../../utils";

class MenuList extends React.Component {
	render() {
		return (
			<List component="nav">
				{/* Quando não houver collapse no item de menu, usa-se o componente MenuItem */}
				<MenuItem to={SystemPath.HOME} primary="Início">
					<HomeIcon />
				</MenuItem>
				<MenuItem to={SystemPath.DASHBOARD} primary="Dashboard">
					<ArrowRightOutlinedIcon />
				</MenuItem>
				<MenuItem to={SystemPath.LAUDO} primary="Listar Laudos">
					<ArrowRightOutlinedIcon />
				</MenuItem>
			</List>
		);
	}
}
export default MenuList;
